/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class UserPushNotificationTokenDTO extends JSONable{

  userUuid: string | undefined = undefined;
  token: string | undefined = undefined;
  device: string | undefined = undefined;

}
